import React, { useCallback, useState } from "react";
import {
  customerChatCanOpenPaymentModal,
  customerChatPaymentIntentVisible,
  extractCustomerChatPaymentUrl,
  openCustomerChatPaymentUrl,
} from "../../../utils/customerChatPaymentOpen";
import "./CustomerVacationChatPaymentFallback.css";

const HINT =
  "אם חלון התשלום לא נפתח אוטומטית, אפשר ללחוץ על 'פתח קישור תשלום'.";
const BROKEN_MSG =
  "לא הצלחנו להכין קישור תשלום כרגע. נסו שוב או פנו לנציג.";

/**
 * Fallback ידני לתשלום: URL חיצוני (אם קיים) או פתיחה חוזרת של מודאל התשלום.
 */
export default function CustomerVacationChatPaymentFallback({
  payment = null,
  client_actions: clientActions = [],
  disabled = false,
  onManualOpenPaymentModal,
}) {
  const [directUrl, setDirectUrl] = useState(null);

  const visible = customerChatPaymentIntentVisible(payment, clientActions);
  const url = extractCustomerChatPaymentUrl({ payment, client_actions: clientActions });
  const canModal = customerChatCanOpenPaymentModal(payment, clientActions);

  const resetDirect = useCallback(() => setDirectUrl(null), []);

  if (!visible) return null;

  const broken = !url && !canModal;
  if (broken) {
    // eslint-disable-next-line no-console
    console.warn("PAYMENT_URL_MISSING", {
      reason: "no_external_url_and_no_modal_path",
      paymentAvailable: payment?.available,
    });
    return (
      <div className="hr-cvac-payment-fallback" dir="rtl">
        <p className="hr-cvac-payment-fallback__err">{BROKEN_MSG}</p>
      </div>
    );
  }

  const handlePrimary = () => {
    resetDirect();
    if (url) {
      const r = openCustomerChatPaymentUrl(url, { variant: "manual" });
      if (r.showDirectLink) setDirectUrl(url);
      return;
    }
    if (canModal && typeof onManualOpenPaymentModal === "function") {
      // eslint-disable-next-line no-console
      console.info("PAYMENT_MANUAL_OPEN_CLICKED", { mode: "modal" });
      onManualOpenPaymentModal();
    }
  };

  const handleSameTab = () => {
    if (!url) return;
    // eslint-disable-next-line no-console
    console.info("PAYMENT_MANUAL_OPEN_CLICKED", { mode: "same_window_navigation" });
    window.location.href = url;
  };

  return (
    <div className="hr-cvac-payment-fallback" dir="rtl">
      <p className="hr-cvac-payment-fallback__hint">{HINT}</p>
      <div className="hr-cvac-payment-fallback__actions">
        <button
          type="button"
          className="hr-cvac-payment-fallback__btn"
          disabled={disabled}
          onClick={handlePrimary}
        >
          פתח קישור תשלום
        </button>
        {directUrl ? (
          <div className="hr-cvac-payment-fallback__direct">
            הדפדפן חסם חלון חדש —{" "}
            <a href={directUrl} target="_blank" rel="noopener noreferrer">
              לחצו כאן לתשלום
            </a>
            .
            <button type="button" className="hr-cvac-payment-fallback__same-tab" onClick={handleSameTab}>
              או המשיכו באותו חלון
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
}
